export enum MessageBlockType {
  TEXT = 'TEXT',
  MARKDOWN = 'MARKDOWN',
  KPI = 'KPI',
  TABLE = 'TABLE',
  CHART = 'CHART',
  DOCUMENT = 'DOCUMENT',
  VIDEO = 'VIDEO',
  ACTIONS = 'ACTIONS',
  WORKFLOW = 'WORKFLOW',
  SOURCE_REFERENCE = 'SOURCE_REFERENCE',
  METADATA = 'METADATA',
  CLARIFICATION = 'CLARIFICATION',
  WARNING = 'WARNING',
  FEEDBACK = 'FEEDBACK',
}
